




































































































import { snakeCase } from 'lodash'
import { Component, Emit, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../Mixins/ModelSetter'
import { UseFields } from '../../../components/Pi'
import { SelectOptionData } from '../../../components/Pi/types'
import { ActiveBotLicenseSteps, FlowTemplate } from '../types'

@Component({
  data() {
    return {
      snakeCase
    }
  }
})
export default class SelectedTemplateStep extends Mixins<UseFields, ModelSetter>(UseFields, ModelSetter) {
  @VModel() selectedTemplate!: FlowTemplate

  @Prop() channelOptions!: Array<SelectOptionData>

  @Emit()
  updateStep() {
    return ActiveBotLicenseSteps.SelectTemplate
  }

  @Emit()
  complete() {
    return ActiveBotLicenseSteps.ConfigureTemplate
  }

  get disabledCreateButton(): boolean {
    if (this.selectedTemplate) {
      const { config } = this.selectedTemplate

      if (config.data) {
        return config.data.channel === null
      } else {
        return !config.title.trim().length
      }
    }

    return false
  }

  videoModal = false
}
